import { AxiosRequestConfig } from "axios";

export function rewriteAxiosRequestConfig(configParams: {
  config: AxiosRequestConfig;
  baseUrl: string;
  accessToken?: string;
}): any {
  const params = {
    ...configParams.config,
    baseURL: configParams.baseUrl,
  };

  if (configParams?.accessToken) {
    params.headers = {
      ...configParams.config.headers,
      Authorization: configParams.accessToken,
    };
  }

  return params;
}
